import { render, staticRenderFns } from "./Windows8.vue?vue&type=template&id=0ea764c8&scoped=true&"
import script from "./Windows8.vue?vue&type=script&lang=js&"
export * from "./Windows8.vue?vue&type=script&lang=js&"
import style0 from "./Windows8.vue?vue&type=style&index=0&id=0ea764c8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea764c8",
  null
  
)

export default component.exports